import { Button, Tag, Space, Avatar } from "antd";
import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import Table from "../../../shared/components/ui/Table";
import { TableColumns } from "../../../shared/components/ui/Table/types";
import { ISauce } from "../../../redux/@types";
import { useRemoveSauce } from "../hooks/useRemoveSauce";
import { saucesService } from "../../../shared/services";
import { PATH_S3_BUCKET } from "../../../shared/utils/constants";

export const TableSauces = () => {
  const navigate = useNavigate();
  const { showDeleteConfirm, setTableProps } = useRemoveSauce();
 
  const handleNavigateEdit = (id: number) => {
    navigate(`/sauce/${id}`);
  };

  const columns: TableColumns<ISauce> = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      filterType: "text",
    },
    {
      title: "Imagen",
      dataIndex: "path_image",
      key: "path_image",
      width: 80,
      render: (_, item) => (
        <Avatar
          size={48}
          src={item.path_image ? `${PATH_S3_BUCKET}/${item.path_image}` : undefined}
          style={{ borderRadius: 8 }}
        >
          {!item.path_image && "—"}
        </Avatar>
      ),
    },
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      filterType: "text",
    },
    {
      title: "Estado",
      dataIndex: "status",
      key: "status",
      render: (_, item) => {
        return (
          <Tag
            color={item.status === "active" ? "green" : "red"}
            style={{
              borderRadius: 8,
              padding: "2px 10px",
              fontSize: 11,
              fontWeight: 500,
              border: "none",
            }}
          >
            {item.status === "active" ? "Activo" : "Inactivo"}
          </Tag>
        );
      },
      filters: [
        {
          text: "Activo",
          value: "active",
        },
        {
          text: "Inactivo",
          value: "inactive",
        },
      ],
    },
    {
      title: "Acciones",
      key: "operation",
      render: (_, item: ISauce) => {
        return (
          <Space size={6}>
            <Button
              type="default"
              icon={<EyeOutlined />}
              size="middle"
              onClick={() => handleNavigateEdit(item.id)}
              style={{
                borderRadius: 8,
                fontWeight: 500,
                fontSize: 12,
              }}
            >
              Ver
            </Button>
            <Button
              type="primary"
              icon={<EditOutlined />}
              size="middle"
              onClick={() => handleNavigateEdit(item.id)}
              style={{
                borderRadius: 8,
                fontWeight: 500,
                fontSize: 12,
                backgroundColor: "#fa8c16",
                borderColor: "#fa8c16",
              }}
            >
              Editar
            </Button>
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="middle"
              onClick={() => showDeleteConfirm(item.id, item.name)}
              style={{
                borderRadius: 8,
                fontWeight: 500,
                fontSize: 12,
                padding: "0 10px",
              }}
            >
              Eliminar
            </Button>
          </Space>
        );
      },
    },
  ];

  return (
    <Table<ISauce>
      columns={columns}
      fetchQueryProps={{
        $sort: { id: -1 },
      }}
      service={saucesService}
      onLoad={setTableProps}
    />
  );
};
